import React from 'react';
import { GaugeIcon } from 'lucide-react';
import { promiseItems } from '../data/content';
import { Reveal } from './showcase/Reveal';
import { LatencyVignette } from './showcase/LatencyVignette';
export function PromiseSection() {
  return <section id="promise" aria-labelledby="promise-title" className="border-b border-white/5 bg-ink-800" data-id="element-226" data-mp="3omqv6q23sj1y">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-227" data-mp="3fnm0xvxkrbvl">
        <Reveal data-id="element-228" data-mp="3fox53wuxmln8">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-229" data-mp="3fl9b6wlkrx7z">
            Under the hood
          </p>
          <h2 id="promise-title" className="mt-5 max-w-2xl font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-230" data-mp="35owio21rnpet">
            Built to keep the promise.
          </h2>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-white/60" data-id="element-231" data-mp="13wrqqqk9os43">
            Speed to lead is either engineered or it is a slogan. Here is exactly how the
            under 60 seconds number holds up.
          </p>
        </Reveal>

        <div className="mt-12 grid gap-8 lg:grid-cols-[1.15fr_1fr] lg:items-start lg:gap-12" data-id="element-232" data-mp="2gccfjoijp3d5">
          <ul className="space-y-4" data-id="element-233" data-mp="22ckytg0n98vg">
            {promiseItems.map((item, index) => <Reveal key={item.title} delay={0.06 * index} data-id="element-234" data-mp="22exqikw7exlp" data-mpi={index}>
                <li className="flex flex-col gap-4 rounded-xl border border-white/10 bg-ink-700 p-7 sm:flex-row sm:gap-6" data-id="element-235" data-mp="26ey3e13nn0qn">
                  <span className="flex h-10 w-10 flex-none items-center justify-center rounded-lg border border-brand/30 bg-brand/10" data-id="element-236" data-mp="2u5u1ffypes6c">
                    <GaugeIcon className="h-5 w-5 text-brand" aria-hidden="true" data-id="element-237" data-mp="2lbyvw6to6zq6" />
                  </span>
                  <div data-id="element-238" data-mp="2pcivdh1puffh">
                    <h3 className="font-display text-lg font-semibold tracking-tight text-white" data-id="element-239" data-mp="2pbpsir5voa2m">
                      {item.title}
                    </h3>
                    <p className="mt-2 text-sm leading-relaxed text-white/60" data-id="element-240" data-mp="3ht39p0rcbmp5">
                      {item.body}
                    </p>
                  </div>
                </li>
              </Reveal>)}
          </ul>

          <Reveal delay={0.1} data-id="element-241" data-mp="3norymex77an1">
            <LatencyVignette data-id="element-242" data-mp="3noi88q88r1gt" />
          </Reveal>
        </div>
      </div>
    </section>;
}